<script lang="ts">
import { defineComponent } from 'vue'

/**
 * MemberAvatar
 */
export default defineComponent({
  props: {
    /**
     * The members first name
     */
    firstname: {
      type: String,
      required: true,
    },
    lastname: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    userInitials(): string {
      return `${this.firstname.charAt(0)}${this.lastname.charAt(0)}`
    },
  },
})
</script>

<template>
  <div class="dp-container">
    <span class="relative font-black text-pure-white">
      {{ userInitials }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.dp-container {
  @apply relative flex items-center justify-center p-3 italic;

  clip-path: circle(closest-side at 50%);
  background-color: #fff;
  background-size: 100% 100%;
  background-position:
    0px 0px,
    0px 0px,
    0px 0px;
  background-image:
    conic-gradient(
      from 215deg at 50% 50%,
      #ffffff00 30%,
      v-bind(color) 50%,
      #ffffff00 70%
    ),
    conic-gradient(
      from 90deg at 50% 50%,
      #ffffff00 30%,
      v-bind(color) 50%,
      #ffffff00 70%
    ),
    conic-gradient(
      from 330deg at 50% 50%,
      #ffffff00 30%,
      v-bind(color) 50%,
      #ffffff00 70%
    );

  &::before {
    @apply absolute h-[85%] w-[85%] bg-black;

    content: '';
    display: block;
    clip-path: circle(closest-side at 50%);
  }
}
</style>
